import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <Link to="/" className="text-2xl font-bold text-foreground-950">
              {siteConfig.logo}
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              {siteConfig.tagline}
            </p>
          </div>

          <div>
            <h5 className="text-sm font-semibold text-foreground-950 mb-4">快速导航</h5>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">首页</Link></li>
              <li><Link to="/category/all" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">分类导航</Link></li>
              <li><Link to="/article/guide" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">使用指南</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h5 className="text-sm font-semibold text-foreground-950 mb-4">热门分类</h5>
            <ul className="space-y-2">
              <li><Link to="/category/search" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">搜索引擎</Link></li>
              <li><Link to="/category/news" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">新闻资讯</Link></li>
              <li><Link to="/category/video" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">视频娱乐</Link></li>
              <li><Link to="/category/shopping" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">购物电商</Link></li>
            </ul>
          </div>

          <div>
            <h5 className="text-sm font-semibold text-foreground-950 mb-4">帮助支持</h5>
            <ul className="space-y-2">
              <li><Link to="/article/guide" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">使用指南</Link></li>
              <li><Link to="/article/access-methods" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">访问方法</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">联系我们</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {siteConfig.name}. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">使用条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}